import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate, Link, NavLink } from "react-router-dom"
import { logout } from "../store/auth"
import { cartQuantity } from "../util"
import { fetchGuestCart, fetchUserCart } from "../store/cart"
import { ScrollTextIcon } from "lucide-react"
import logo from "../assets/carousel/Logo.png"
import "./styles/Navbar.css"
import { Phone, MessageSquare } from "lucide-react"

function Navbar() {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const cart = useSelector((state) => state.cart)
  const auth = useSelector((state) => state.auth)

  const cartDisplayQuantity = useSelector((state) =>
    cartQuantity(state.cart.cartItems ? state.cart.cartItems : [])
  )

  const [showCartDropdown, setShowCartDropdown] = useState(false)

  const toggleCartDropdown = () => {
    // Navigate to the cart component
    navigate("/cart")
  }

  useEffect(() => {
    if (auth.id) {
      dispatch(fetchUserCart())
    } else {
      dispatch(fetchGuestCart())
    }
  }, [auth, dispatch])

  const handleLogin = () => {
    navigate("/login")
  }

  return (
    <div className="navbar1">
      <div className="navbar-list">
        <NavLink
          to={"/"}
          className={({ isActive, isPending }) =>
            `navbar-item ${isActive ? "btn-active" : ""}`
          }
        >
          Home
        </NavLink>
        {auth.isAdmin && (
          <NavLink
            to={"/admin"}
            className={({ isActive, isPending }) =>
              `navbar-item ${isActive ? "btn-active" : ""}`
            }
          >
            Admin
          </NavLink>
        )}
        {auth.isAdmin && (
          <NavLink
            to={"/products"}
            className={({ isActive, isPending }) =>
              `navbar-item ${isActive ? "btn-active" : ""}`
            }
          >
            Products
          </NavLink>
        )}
        {auth.isAdmin && (
          <NavLink
            to={"/orders"}
            className={({ isActive, isPending }) =>
              `navbar-item ${isActive ? "btn-active" : ""}`
            }
          >
            Orders
          </NavLink>
        )}
        {/* <NavLink
          to={"/orders"}
          className={({ isActive, isPending }) =>
            `navbar-item${isActive ? "btn-active" : ""}`
          }
        >
          Orders
        </NavLink> */}
      </div>

      {auth.id && (
        <div
          className="navbar-item"
          onClick={() => navigate("/account/wishlist")}
        >
          <ScrollTextIcon className="scrolltext-icon" size={32} />
        </div>
      )}

      <label tabIndex={0} className="cart-and-indicator-icon">
        <div className="indicator" onClick={toggleCartDropdown}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="cart-icon"
            fill="none"
            viewBox="0 0 26 26"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
            />
          </svg>
          <span className="badge badge-sm indicator-item">
            {cartDisplayQuantity}
          </span>
        </div>
      </label>

      <div className="flex-none">
        {auth.id ? (
          <>
            {auth.avatar ? (
              <img
                src={auth.avatar}
                className="logged-in-avatar"
                onClick={() => navigate("/account")}
              />
            ) : (
              <Link to="/account">
                <span className="px-3">Account</span>
              </Link>
            )}
          </>
        ) : (
          <button className="Btn" onClick={() => handleLogin()}>
            <div className="sign">
              <svg viewBox="0 0 512 512">
                <path d="M217.9 105.9L340.7 228.7c7.2 7.2 11.3 17.1 11.3 27.3s-4.1 20.1-11.3 27.3L217.9 406.1c-6.4 6.4-15 9.9-24 9.9c-18.7 0-33.9-15.2-33.9-33.9l0-62.1L32 320c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l128 0 0-62.1c0-18.7 15.2-33.9 33.9-33.9c9 0 17.6 3.6 24 9.9zM352 416l64 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32l64 0c53 0 96 43 96 96l0 256c0 53-43 96-96 96l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"></path>
              </svg>
            </div>
            <div className="text-login-btn">Login</div>
          </button>
        )}
      </div>
    </div>
  )
}

export default Navbar
